export type LocationAccuracyQuality = 'excellent' | 'warning' | 'critical';

const EXCELLENT_ACCURACY_IN_METERS = 50;
const USABLE_ACCURACY_IN_METERS = 100;

export function accuracyQuality(accuracy: number): LocationAccuracyQuality {
  if (accuracy <= EXCELLENT_ACCURACY_IN_METERS) {
    return 'excellent';
  }

  return accuracy <= USABLE_ACCURACY_IN_METERS ? 'warning' : 'critical';
}
